import styled from 'styled-components'
import { Box } from 'pcln-design-system'

const Container = styled(Box)`
  display: inline-block;
  font-size: ${(props) => props.fontSize};
  line-height: ${(props) => props.fontSize};
  height: ${(props) => props.fontSize};
`

export default Container
